import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

import { UbiFilterService } from '../../services';
import { ApiService, MetadataService, ExpressionFilter, ExpressionRule, Operator, Condition } from '../../../ubi-core/ubi-core.module';

declare var $: any;

@Component({
  selector: 'ubi-filter',
  templateUrl: './ubiFilter.html',
})
export class UbiFilterComponent implements OnInit, AfterViewInit {

  @Input() filters: any;

  @Input() selectedFilter: ExpressionFilter;

  constructor(private filterservice: UbiFilterService) {
  }

  ngOnInit() {

  }

  ngAfterViewInit() {

    console.log(this.selectedFilter);

    this._queryBuilder(this.filters, this.selectedFilter);

    $('#builder').on('afterDeleteGroup.queryBuilder afterAddRule.queryBuilder afterDeleteRule.queryBuilder ' +
      'afterUpdateRuleValue.queryBuilder afterUpdateRuleOperator.queryBuilder afterUpdateGroupCondition.queryBuilder ' +
      'afterUpdateRuleFilter.queryBuilder',
      (e, args) => {
        this.filterservice.setCurrentFilter($('#builder').queryBuilder('getRules'));
        this.filterservice.setCurrentFilterNL($('#builder').queryBuilder('getNL'));


      }
    );
  }

  private _queryBuilder(filters: any[], initial_rules: any) {

    $('#builder').queryBuilder({
      allow_groups: false,
      conditions: ['AND'],
      lang_code: 'pt-PT',
      operators: ['begins_with', 'not_begins_with', 'contains', 'not_contains', 'equal', 'not_equal',
        'less', 'less_or_equal', 'greater', 'greater_or_equal', 'between',
        'is_empty', 'is_not_empty', 'is_null', 'is_not_null'],
      filters: filters,
      rules: initial_rules,
      'filter-description': { mode: 'inline' }
    });

  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiFilter/ubiFilter.component.ts